import { render, staticRenderFns } from "./ThePublicDocumentGateway.vue?vue&type=template&id=22ab26d4&scoped=true&"
import script from "./ThePublicDocumentGateway.vue?vue&type=script&lang=js&"
export * from "./ThePublicDocumentGateway.vue?vue&type=script&lang=js&"
import style0 from "./ThePublicDocumentGateway.vue?vue&type=style&index=0&id=22ab26d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab26d4",
  null
  
)

export default component.exports